
import React, { useState, useRef, useCallback, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Spinner, Form } from "react-bootstrap";
import { routes } from '../routes/routes-names';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { organizationService } from "../lib/api/organization";
import { RegPayDetailsFormType } from "../types/common";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";
import { eventService } from "../lib/api/event";
import { LocalStorageManager } from '../lib/localStorage-manager';
import Swal from "sweetalert2";
import RegisteredDoctorsTable from "./RegisteredDoctorsTable";
import CreateAttendanceDelegateModal from "./CreateAttendanceDelegateModal";
import "../assets/styles/event-doctor-info.css";

const isDelegate = () =>
  !!sessionStorage.getItem("ATTENDANCE_TOKEN");

const STORAGE_SELECTED_EVENT = "cme_selected_event_id";

const EventDoctorsInfoPage: React.FC = () => {

  const [showDelegateModal, setShowDelegateModal] = useState(false);
  
   interface AttendanceRespPoint {
  eventDate: string;
  weightage: number;
}
  interface eventType {
  id: number;
  nameOfEvent: string;
  attendanceRespPoints:AttendanceRespPoint[];
  numberOfPeople?: number;
  eventCategory: string;
  eventType: string;
  department: string;
  speciality: string;
  startDate: string;
  endDate: string;
  paymentStatus: string;
  organizationType: string;
  programSheet1: string;
  programSheet2: string;
  programSheet3: string;
  programSheet4: string;
  programSheet5: string;
  letterHost: string;
}

  interface attendanceList {
    attendanceDate: string;
    latitude: string;
    longitude: string;
    photo: string;
  }
  interface DoctorItem {
    doctorId: number;
    fmrNo: string;
    doctorName: string;
    latitude: string;
    longitude: string;
    createdon: string;
    contactNumber: string;
    email: string;
    attendanceList: attendanceList[];
  }
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedEvent, setSelectedEvent] = useState('');
  const [eventData, setEventData] = useState<any[]>([]);
  const [eventId, setEventId] = useState<any>();
  const [eventDetails, setEventDetails] = useState<eventType>();
  const [doctordata, setDoctorData] = useState<DoctorItem[]>([]);
  const [loading, setLoading] = useState(false);
  const finishBarRef = useRef<HTMLDivElement>(null);
  const normalizeDate = (dateStr: string) =>
    moment(dateStr, ["DD-MM-YYYY", "YYYY-MM-DD", moment.ISO_8601], true).format("DD-MM-YYYY");


  function getDateRange(start: string, end: string): string[] {
  const startDate = moment(start, "DD-MM-YYYY");
  const endDate = moment(end, "DD-MM-YYYY");

  if (!startDate.isValid() || !endDate.isValid()) {
    console.error("Invalid date range:", start, end);
    return [];
  }

  const dates: string[] = [];
  const current = startDate.clone();

  while (current.isSameOrBefore(endDate, "day")) {
    dates.push(current.format("DD-MM-YYYY"));
    current.add(1, "day");
  }

  return dates;
}


// Example usage for 2026:
// getDateRange("10-01-2026", "12-01-2026") 
// Result: ["10-01-2026", "11-01-2026", "12-01-2026"]

  const fetchRegisteredDoctorsByEvent = useCallback(async (eventId:any) => {
    setLoading(true);
    try {
      const { success, data } = await eventService.getDoctorDetailsByEventIdStatus(eventId, 'pen');
      if (data && data.length > 0) {
        setDoctorData(data);
      } else {
        setDoctorData([]);
      }
    } catch (err) {
      console.error("Error fetching approvals:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  const getEventsbyOrgid = useCallback(async () => {
    try {
      const orgData = localStorage.getItem("orgdata");
      if (orgData) {
        const retrievedObject = JSON.parse(orgData);
        const { data } = await eventService.getAllEventsbyOrgid(retrievedObject.id);
        // Show only approved events
        const approvedEvents = Array.isArray(data) ? data.filter((event:any) => event.paymentStatus === 'ver') : [];
        setEventData(approvedEvents);
      }
    } catch {
    }
  }, []);

  useEffect(() => {
    getEventsbyOrgid();
    if (location.state && (location.state as any).focusFinish && finishBarRef.current) {
      setTimeout(() => finishBarRef.current?.scrollIntoView({ behavior: "smooth", block: "end" }), 300);
    }
  }, [getEventsbyOrgid, location.state]);

  const handleEventChange = (event: any) => {
    const nextId = event.target.value;
    setSelectedEvent(nextId);
    localStorage.setItem(STORAGE_SELECTED_EVENT, nextId || "");
    const result = eventData.find(item => item.id === parseInt(nextId));
    if (result !== undefined) {
      setEventDetails(result);
      setEventId(nextId);
      fetchRegisteredDoctorsByEvent(nextId);
    }
  };

  // Restore previous selection once events are loaded
  useEffect(() => {
    if (!eventData.length) return;
    const storedId = localStorage.getItem(STORAGE_SELECTED_EVENT);
    if (storedId) {
      const result = eventData.find((item) => item.id === parseInt(storedId));
      if (result) {
        setSelectedEvent(storedId);
        setEventDetails(result);
        setEventId(storedId);
        fetchRegisteredDoctorsByEvent(storedId);
      }
    }
  }, [eventData, fetchRegisteredDoctorsByEvent]);

  const handleRegiStration = (selectedDay?: string, forceSubsequentDay?: boolean) => {
    const token = sessionStorage.getItem("ATTENDANCE_TOKEN");
    const selectedDayMoment = selectedDay
      ? moment(selectedDay, ["DD-MM-YYYY", "YYYY-MM-DD", moment.ISO_8601], true)
      : null;
    const eventStartMoment = eventDetails?.startDate
      ? moment(eventDetails.startDate, ["DD-MM-YYYY", "YYYY-MM-DD", moment.ISO_8601], true)
      : null;
    const isSubsequentDay =
      typeof forceSubsequentDay === "boolean"
        ? forceSubsequentDay
        : (
            !!selectedDayMoment?.isValid() &&
            !!eventStartMoment?.isValid() &&
            !selectedDayMoment.isSame(eventStartMoment, "day")
          );

    if (token) {
      // delegate flow → keep token in URL
      navigate(`${routes.capture_photo}?token=${token}`, {
      state: {
        isFirstDay:true,
        isSubsequentDay,
        doctorId: null,
        doctorName: null,
        eventId: selectedEvent,
        day: selectedDay ?? null
      }
    });
    } else {
      // normal org user
      navigate(routes.capture_photo, {
      state: {
        isFirstDay:true,
        isSubsequentDay,
        doctorId: null,
        doctorName: null,
        eventId: selectedEvent,
        day: selectedDay ?? null
      }
    });
    }
  };

  const onCapturePhoto = (doctorId: number, doctorName: string, day: any) => {
    // Avoid logging sensitive identifiers
    navigate(routes.capture_photo, {
      state: {
        isFirstDay:true,
        doctorId: doctorId,
        doctorName: doctorName,
        eventId: eventId,
        day: day
      }
    });


  };

  const handleFinishEvent = useCallback(async () => {
    const proposedCount = Number(
      (eventDetails as any)?.numberOfPeople ??
      eventDetails?.attendanceRespPoints?.length ??
      doctordata.length
    );

    const dayWiseHtml = (eventDetails?.attendanceRespPoints || [])
      .map((item) => {
        const dayKey = normalizeDate(item.eventDate);
        const recordedCount = doctordata.reduce((acc, doc) => {
          const hasForDay = (doc.attendanceList || []).some(
            (a) => normalizeDate(a.attendanceDate) === dayKey
          );
          return acc + (hasForDay ? 1 : 0);
        }, 0);
        return `<li style="list-style: disc; padding: 2px 0; margin: 0; background: transparent !important;">${moment(item.eventDate).format("DD-MM-YYYY")}: <strong>${recordedCount}</strong> recorded</li>`;
      })
      .join("");

    const result = await Swal.fire({
      title: "Finish & Lock Event?",
      html: `
        <div class="text-start small">
          <p><strong>Proposed doctor count:</strong> ${proposedCount}</p>
          ${dayWiseHtml ? `<div class="mb-2"><strong>Day-wise recorded:</strong><ul class="mb-0 ps-3" style="padding-left:16px; margin:0;">${dayWiseHtml}</ul></div>` : ""}
          <div class="form-check mt-3">
            <input class="form-check-input" type="checkbox" id="attendance-confirm">
            <label class="form-check-label" for="attendance-confirm">
              I have recorded all attendance
            </label>
          </div>
        </div>
      `,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Finish & Lock Event",
      cancelButtonText: "Keep Registering",
      focusConfirm: false,
      preConfirm: () => {
        const checkbox = document.getElementById("attendance-confirm") as HTMLInputElement | null;
        if (!checkbox?.checked) {
          Swal.showValidationMessage("Please confirm you have recorded all attendance");
          return false;
        }
        return true;
      },
    });

    if (!result.isConfirmed) return;

    try {
      setLoading(true);
      const eventApprovalInfo = {
        approval_status: "com",
        remarks: "event Completed",
      };
      const { success } = await eventService.updateEventApprovals(eventId, eventApprovalInfo);
      if (success) {
        Swal.fire({
          title: "Event locked",
          text: "Attendance has been locked and the event marked complete.",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate(routes.userLayout);
        });
      } else {
        Swal.fire({
          title: "Update failed",
          text: "Event failed to complete",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (err) {
      Swal.fire("Error", "Event failed to complete", "error");
    } finally {
      setLoading(false);
    }
  }, [doctordata, eventId, navigate]);


  return (
    <div className="cme-page">
      <div className="cme-container mt-0">
        <h2 className="cme-title">Event Doctor Registration </h2>

        {/* Event Info Section */}
        <div className="card shadow-sm mb-4 border-info">
          <div className="row p-3">
            <div className="col-md-4"><b>Select Event Name</b></div>
            <div className="col-md-4">
              <select
                    value={selectedEvent}
                    onChange={handleEventChange}
                    className="form-select"
                    >
                <option value="">-- Please choose an option --</option>
                    {eventData.map((type) => (
                        <option key={type.id} value={type.id}>
                          {type.nameOfEvent}
                        </option>
                      ))}
                    </select>
              </div>
          </div>

          {eventDetails !== undefined && <>
            <div className="card-body">

              <div className="row mb-3">
                <div className="col-md-4">
                  <label className="fw-semibold text-secondary">Event Name:</label>
                  <div>{eventDetails.nameOfEvent}</div>
                </div>

                <div className="col-md-4">
                  <label className="fw-semibold text-secondary">Event Type:</label>
                  <div>{eventDetails.eventCategory}</div>
                </div>

                <div className="col-md-4">
                  <label className="fw-semibold text-secondary">Status:</label>
                  <div><b>
                    {eventDetails.paymentStatus === 'pen' && "Pending"}
                    {eventDetails.paymentStatus === 'rej' && "Rejected"}
                    {eventDetails.paymentStatus === 'ver' && "Verified"}
                    {eventDetails.paymentStatus === 'apr' && "Approved"}

                  </b>
                  </div>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-4">
                  <label className="fw-semibold text-secondary">Start Date:</label>
                  <div>{eventDetails.startDate}</div>
                </div>

                <div className="col-md-4">
                  <label className="fw-semibold text-secondary">End Date:</label>
                  <div>{eventDetails.endDate}</div>
                </div>
                
              </div>
                {eventDetails.paymentStatus !== 'pen' &&
                          <table className="w-100 align-middle" style={{ tableLayout: "fixed" }}>
                           <colgroup>
                            <col style={{ width: "35%" }} />
                            <col style={{ width: "20%" }} />
                            <col style={{ width: "25%" }} />
                            <col style={{ width: "20%" }} />
                           </colgroup>
                          <tr>
                            <th>Date</th>
                            <th>Points</th>
                            <th>Recorded</th>
                            <th></th>
                          </tr>
                          {eventDetails.attendanceRespPoints && eventDetails.attendanceRespPoints.length>0 && eventDetails.attendanceRespPoints.map((item, index) => {
                            const isToday = moment(item.eventDate).isSame(moment(), "day");
                            const dayKey = normalizeDate(item.eventDate);
                            const recordedCount = doctordata.reduce((acc, doc) => {
                              const hasForDay = (doc.attendanceList || []).some(
                                (a) => normalizeDate(a.attendanceDate) === dayKey
                              );
                              return acc + (hasForDay ? 1 : 0);
                            }, 0);
                            return (
                              <tr key={item.eventDate}>
                                <td className="fw-semibold">
                                  {moment(item.eventDate).format("DD-MM-YYYY")}
                                </td>

                                <td>
                                  <Form.Control
                                    type="number"
                                    disabled={true}
                                    min={0}
                                    max={10}
                                    value={item.weightage}
                                    size="sm"
                                    className="w-auto"
                                    style={{ minWidth: "80px", maxWidth: "120px" }}
                                  />
                                </td>
                                <td>
                                  <span className="badge bg-info text-dark">
                                    {recordedCount} recorded
                                  </span>
                                </td>
                                <td className="text-center">
                                  <button
                                    type="button"
                                    className="cme-button w-100"
                                    disabled={!eventId || !isToday}
                                    onClick={() => handleRegiStration(item.eventDate, index > 0)}
                                    style={!isToday ? { backgroundColor: "#b7c5d1", borderColor: "#b7c5d1" } : undefined}
                                  >
                                    Register
                                  </button>
                                </td>
                              </tr>
                              
                            );
                          })}
                          </table>
                        }

            </div>

            {eventDetails.paymentStatus === 'ver' &&
              <>
                <CreateAttendanceDelegateModal
                  show={showDelegateModal}
                  onClose={() => setShowDelegateModal(false)}
                  eventId={eventDetails.id}
                  eventName={eventDetails.nameOfEvent}
                />
              </>
            }
</>}
</div>

        {loading === true &&
          <div className="d-flex justify-content-center mt-5">
            <Spinner animation="border" />
          </div>
        }


        {/* Doctors List */}

        {eventDetails !== undefined && doctordata.length > 0 && <>
          <RegisteredDoctorsTable
            doctors={doctordata}
            eventDates={getDateRange(eventDetails.startDate, eventDetails.endDate)}
            onCapture={onCapturePhoto}
          />
          {eventDetails && doctordata.length === 0 && !loading && (
            <div className="alert alert-info mt-3">
              No doctors registered yet.
            </div>
          )}
        </>
        }

        {eventDetails?.paymentStatus === 'ver' && !isDelegate() && (
          <div className="finish-bar mt-4" ref={finishBarRef}>
            <div className="finish-bar__content">
              <div className="finish-bar__copy">
                <div className="fw-semibold">Finish &amp; Lock Event (after attendance)</div>
                <small className="text-muted">Locks attendance and completes the event. This cannot be undone.</small>
              </div>
              <button
                type="button"
                className="finish-bar__cta"
                disabled={
                  !eventId ||
                  loading ||
                  !eventDetails ||
                  !moment(eventDetails.endDate, ["DD-MM-YYYY", "YYYY-MM-DD"]).isSameOrBefore(moment(), "day")
                }
                onClick={handleFinishEvent}
              >
                Finish &amp; Lock Event (after attendance)
              </button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default EventDoctorsInfoPage;
